/* unplugin-vue-components disabled */import { render } from "./UpgradeMembership.vue?vue&type=template&id=b45e9a32&scoped=true"
import script from "./UpgradeMembership.vue?vue&type=script&lang=js"
export * from "./UpgradeMembership.vue?vue&type=script&lang=js"

import "./UpgradeMembership.vue?vue&type=style&index=0&id=b45e9a32&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b45e9a32"]])

export default __exports__